import {
  CategoriesService,
  TagsService,
  MaterialsService,
  SuppliersService,
  ColorsService,
} from '../api';
import { normalizePagedApiResponse } from './normalizePagedApiResponse';
/** Fila de etiqueta con id requerido (API de listado siempre devuelve id). */
export type CatalogTagRow = { id: number; name: string; color?: string };

export type CatalogPageArgs = { page: number; limit: number; query: string };

export async function fetchCategoriesPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await CategoriesService.categoriesControllerFindAll(
    page,
    limit,
    q ? q : undefined,
    undefined,
  );
  const { items, totalPages } = normalizePagedApiResponse<{ id: number; name: string }>(response);
  return { items, totalPages };
}

export async function fetchMaterialsPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await MaterialsService.materialsControllerFindAll(
    page,
    limit,
    q ? q : undefined,
  );
  const { items, totalPages } = normalizePagedApiResponse<{ id: number; name: string }>(response);
  return { items, totalPages };
}

export async function fetchColorsPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await ColorsService.colorsControllerFindAll(page, limit, q ? q : undefined);
  const { items, totalPages } = normalizePagedApiResponse<{ id: number; name: string }>(response);
  return { items, totalPages };
}

export async function fetchSuppliersPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await SuppliersService.suppliersControllerFindAll(
    page,
    limit,
    q ? q : undefined,
    undefined,
    undefined,
  );
  const { items, totalPages } = normalizePagedApiResponse<{ id: number; name: string }>(response);
  return { items, totalPages };
}

/** Proveedores activos (asignación de inventario y flujos operativos). */
export async function fetchActiveSuppliersPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await SuppliersService.suppliersControllerFindAll(
    page,
    limit,
    q ? q : undefined,
    undefined,
    'ACTIVE',
  );
  const { items, totalPages } = normalizePagedApiResponse<{ id: number; name: string }>(response);
  return { items, totalPages };
}

export async function fetchTagsPage({ page, limit, query }: CatalogPageArgs) {
  const q = query.trim();
  const response = await TagsService.tagsControllerFindAll(page, limit, q ? q : undefined);
  const { items, totalPages } = normalizePagedApiResponse<Record<string, unknown>>(response);
  const mapped: CatalogTagRow[] = items.map((item) => ({
    id: Number(item.id),
    name: String(item.name ?? ''),
    color: typeof item.color === 'string' ? item.color : undefined,
  }));
  return { items: mapped, totalPages };
}
